import { Typography } from "@mui/material";
import { Box } from "@mui/system";

interface IProps {
  data: {
    google2fa_code: string;
    google2fa_qrcode: string;
  },
  code?: string;
  setCode: (code: string) => void;
}

export default function BackupKey({ data }: IProps){
  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        margin: "0 auto",
        maxWidth: 500,
        minHeight: 200,
        alignItems: "center",
        flexWrap: "wrap",
      }}
    >
      <img src={require("../../../../assets/download-apple.svg").default} alt="qr code" style={{ width: "90px", height: "90px", userSelect: "none" }} />
      <Box sx={{ flex: 1, p: 2, maxWidth: "400px" }}>
        <Typography variant="body2" gutterBottom>
          Resetting your Google Authentication requires opening a support ticket and takes at least 7 days to process.        </Typography>
        <Typography variant="subtitle1" gutterBottom sx={{ backgroundColor: "rgb(250, 250, 250)", maxWidth: "200px", textAlign: "center", p: "10px 20px" }}>
          {data.google2fa_code}
        </Typography>
      </Box>
    </Box>
  )
}
